import Konva from "konva";
import { DMCButton } from "../KObjects/DMCButton";
import store from "../../../store/store";

// TOOLS
const rectangleTool = require("./RectangleTool");

export class Button extends rectangleTool.Rectangle {
  constructor() {
    super();
    this.currentObject = null;
    this.currentShapeConfig = {};
    this.interval = false;
    this.origin = {};
    this.name = "Button";
    this.nameProject = "";
    this.type = "widget";
    this.currentMousePosDown = "";
    this.currentOptions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      scaleX: 0,
      scaleY: 0,
    };
  }
  button(nameProject) {
    this.nameProject = nameProject;
  }
  createControllerObject(name, konvaObject) {
    return new DMCButton(name, konvaObject, this.nameProject);
  }

  createNew(controllerProject, dataScrolling = null) {
    const currentMousePos = controllerProject.collectCurrentMousePosition();
    this.currentShapeConfig = {};
    this.currentShapeConfig.scaleX = 1;
    this.currentShapeConfig.scaleY = 1;
    this.currentShapeConfig.x = Math.round(currentMousePos.x / controllerProject.scale);
    this.currentShapeConfig.y = Math.round(currentMousePos.y / controllerProject.scale);
    this.currentShapeConfig.fill = controllerProject.mainColor;
    this.currentShapeConfig.stroke = controllerProject.secondaryColor;
    this.currentShapeConfig.strokeWidth = 5;
    this.currentShapeConfig.draggable = true;

    this.currentShapeConfig.dragBoundFunc = function (pos) {
      let x = pos.x;
      let y = pos.y;
      if (dataScrolling != null) {
        if (dataScrolling.axe) {
          x = this.absolutePosition().x;
        } else {
          y = this.absolutePosition().y;
        }
      }

      if (!controllerProject.canObjectMove) {
        return {
          x: this.absolutePosition().x,
          y: this.absolutePosition().y,
        };
      } else {
        return {
          x: x,
          y: y,
        };
      }
    };

    this.currentObject = this.createNewForm();
    controllerProject.addElementToCurrentLayer(this.currentObject);
    this.currentShapeConfig = this.currentObject.attrs;
  }

  createNewForm() {
    const rect = new Konva.Rect(this.currentShapeConfig);
    const nameProject = this.nameProject;

    rect.on("mouseup touchend", () => {
      store.dispatch("buttonClicked", nameProject).creation;
    });

    rect.opacity(0.5);

    return rect;
  }

  createTransformer(elementToTransform) {
    return new Konva.Transformer({
      node: elementToTransform,
      keepRatio: false,
      enabledAnchors: [
        "top-left",
        "top-center",
        "top-right",
        "middle-right",
        "middle-left",
        "bottom-center",
        "bottom-left",
        "bottom-right",
      ],
    });
  }

  mouseDown(controllerProject) {
    this.currentMousePosDown = controllerProject.collectCurrentMousePosition();

    this.createNew(controllerProject);
    this.origin.x = controllerProject.collectCurrentMousePosition().x / controllerProject.scale;
    this.origin.y = controllerProject.collectCurrentMousePosition().y / controllerProject.scale;

    if (!this.interval) {
      this.interval = setInterval(() => {
        const currentMousePos = controllerProject.collectCurrentMousePosition();
        const distanceX = Math.round(Math.abs(this.origin.x - currentMousePos.x / controllerProject.scale));
        const distanceY = Math.round(Math.abs(this.origin.y - currentMousePos.y / controllerProject.scale));

        if (currentMousePos.x / controllerProject.scale < this.origin.x) {
          this.currentObject.setAttr("x", Math.round(currentMousePos.x / controllerProject.scale));
        }
        if (currentMousePos.y / controllerProject.scale < this.origin.y) {
          this.currentObject.setAttr("y", Math.round(currentMousePos.y / controllerProject.scale));
        }
        if (controllerProject.shiftKeyPressed) {
          let length = distanceX > distanceY ? distanceY : distanceX;
          length = Math.round(length);
          this.currentObject.setAttr("width", length);
          this.currentObject.setAttr("height", length);
        } else {
          this.currentObject.setAttr("width", distanceX);
          this.currentObject.setAttr("height", distanceY);
        }
        this.updateCurrentOptions(
          this.currentObject.getAttr("x"),
          this.currentObject.getAttr("y"),
          this.currentObject.getAttr("width"),
          this.currentObject.getAttr("height")
        );
      }, 30);
    }
  }

  resetOptions() {
    return {
      x: 0,
      y: 0,
      width: 0,
      height: 0,
      scaleX: 0,
      scaleY: 0,
    };
  }

  setContent(nameProject) {
    this.button(nameProject);
  }

  setConfig(edit) {
    this.edit = edit;
  }

  editNewElement(controllerProject) {
    this.createNew(controllerProject);
    this.currentObject.setAttr("x", this.edit.x);
    this.currentObject.setAttr("y", this.edit.y);
    this.currentObject.setAttr("width", this.edit.width);
    this.currentObject.setAttr("height", this.edit.height);
    this.currentObject.setAttr("scaleX", this.edit.scaleX);
    this.currentObject.setAttr("scaleY", this.edit.scaleY);
    this.edit = "";
    return this.mouseUp(controllerProject);
  }

  updateCurrentOptions(x, y, width, height) {
    this.currentOptions.x = x;
    this.currentOptions.y = y;
    this.currentOptions.width = width;
    this.currentOptions.height = height;
  }
}
